export const SliderData = [
  {
    id: 1,
    cover: "/assets/carousleImages/image10.png",
    title: "Innovative Solutions For Your Business",
    subtitle:
      "We help businesses transform their digital presence with cutting-edge technology and creative strategies that drive real results..",
    desc: "INNOVATION  || QUALITY || EXCELLENCE",
    interval: 5000,
    buttonText: "Get Started",
    buttonLink: "/contact",
    learnMoreLink: "/product#vendoremanagement",
    learnMoreText: "Lern More",
  },
  {
    id: 2,
    cover: "/assets/carousleImages/img03.jpeg",
    title: "Smarter Business. Stronger Growth.",
    subtitle:
      "Unify processes, Automation, Boost savings,Data-driven decisions and Enhance teamwork",
    desc: "FAST || SMART || FLEXIBLE",
    interval: 5000,
    buttonText: "Get Started",
    buttonLink: "/contact",
    learnMoreLink: "/product#vendoremanagement",
    learnMoreText: "Lern More",
  },
  {
    id: 3,
    cover: "/assets/carousleImages/image10.png",
    title: "Innovative Solutions For Your Business",
    subtitle:
      "We help businesses transform their digital presence with cutting-edge technology and creative strategies that drive real results..",
    desc: "INNOVATION  || QUALITY || EXCELLENCE",
    interval: 5000,
    buttonText: "Get Started",
    buttonLink: "/contact",
    learnMoreLink: "/product#vendoremanagement",
    learnMoreText: "Lern More",
  },
  {
    id: 4,
    cover: "/assets/carousleImages/img03.jpeg",
    title: "Simple solutions,Powerful results,Seamlessly integrated.",
    subtitle:
      "Streamline operations, automate tasks, increase savings, make data-driven decisions, and improve collaboration.",
    desc: "SOLUTION || RESULT || INTEGRATION",
    interval: 5000,
    buttonText: "Get Started",
    buttonLink: "/contact",
    learnMoreLink: "/product#vendoremanagement",
    learnMoreText: "Lern More",
  },
];
